import { gql } from '@apollo/client'

const ViewerPageModelViewerSnapshotFragment = gql`
    fragment ViewerPageModelViewerSnapshot on ModelViewerSnapshot {
        id
        position
        target
        feature
        type
        snapshot {
            camera {
                zoom
                position
                up
                target
            }
            dfm {
                feature
                threshold
                direction
            }
            annotations {
                position
            }
            rotation
            part {
                transparent
                patches {
                    color
                    hashcode
                }
            }
            crossSection {
                position
                rotation
            }
            pointToPoint {
                customPoints
                selectedPoints {
                    index
                    type
                }
            }
        }
        createdAt
        updatedAt
        deletedAt
    }
`

const DfmFeedback = gql`
    fragment dfmFeedbackOrderDetailsPage on DfmFeedback {
        id
        title
        link
        severity
        message
        accepted
        modelViewerSnapshots {
            ...ViewerPageModelViewerSnapshot
        }
        isPublished
    }
    ${ViewerPageModelViewerSnapshotFragment}
`
const Holes = gql`
    fragment holes on Hole {
        id
        groupKey
        patches {
            id
        }
        type
        depth
        diameter
        isBlind
        tipAngle
        counterboreDepth
        counterboreDiameter
        countersinkAngle
        countersinkDepth
        countersinkDiameter
        direction
        endPoint
        startPoint
        tapOptions {
            id
            maxDepth
            commonName
        }
        tapAnnotation {
            id
            depth
            tapOption {
                id
                maxDepth
                commonName
            }
        }
    }
`

const Revision = gql`
    fragment revision on Revision {
        id
        version
        modelFileName
        thumbnailUri
        downloadUri
        sceneBundle
        scene {
            featureMapping {
                url
            }
            geometry {
                url
            }
        }
        boundingBox {
            x
            y
            z
        }
        revisionFolderAttachments {
            id
            quoteAttachment {
                id
                attachment {
                    id
                    fileName
                }
            }
        }
    }
`

const BoundingBox = gql`
    fragment boundingBox on BoundingBox {
        width
        length
        thickness
    }
`

const InspectionDocuments = gql`
    fragment inspectionDocuments on InspectionDocument {
        fileName
        type
        mimeType
        downloadUrl
        createdAt
        updatedAt
    }
`

export const fragments = {
    DfmFeedback,
    Holes,
    Revision,
    BoundingBox,
    InspectionDocuments,
}
